export default [
    {
        path: "/tools/email-blast",
        name: "email compose list",
        component: () => import("@/views/Tools/EmailBlast"),
        meta: {
            pageTitle: "Email Blast",
            breadcrumb: [
                {
                    text: 'Email Blast',
                    active: true,
                },
            ],
        },
    },
];
